/* eslint-disable react-hooks/exhaustive-deps */
import { Dropdown } from 'antd';
import UserIcon from './UserIcon';
import { withHiddenApps } from '../../../constants/apps';
import { NOTIFICATION_MODE } from '../../../context/Forms';
import { useMemo } from 'react';
import { usePermissions } from '../../../permissions/usePermissions';
import { useApp } from '../../../helpers/user';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { useResizeContext } from 'datastake-daf/dist/context';
import { MOBILE_W } from 'datastake-daf/src/constants/Style';
import MobileDrawer from './MobileDrawer';

const demo = process.env.REACT_APP_ENV === 'demo';

export const UserDropdownMenu = ({
  user,
  toggleSettingsDrawer = () => { },
  settingsDrawerOpened,
  notificationMode,
  goTo,
  changeNotificationState,
  isUserApproved,
  t = (s) => s,
  isAppNavigation,
  logOut,
  module,
}) => {
  const app = useApp();
  const { windowWidth } = useResizeContext();
  const isMobile = useMemo(() => windowWidth <= MOBILE_W, [windowWidth]);
  const canViewPartners = app === 'tazama';
  const canViewProjects = usePermissions({ permission: 'projects.canView', defaultValue: false });
  const canViewUsers = usePermissions({ permission: 'users.canView', defaultValue: false });
  const canViewSettings = usePermissions({ permission: 'settings.canView', defaultValue: false });
  const hasMultipleApps = useMemo(() =>
    Object.keys(user?.modules || {}).filter((k) => user.modules[k].status === 'approved').length > 1, [user])
  const showApplications = !withHiddenApps.includes(app);

  const companyLogo = useMemo(() => {
    const _arr = Array.isArray(user?.company?.logo) ? user?.company?.logo : (
      user?.company?.logo?.fileList && Array.isArray(user?.company?.logo?.fileList) ?
        user?.company?.logo?.fileList.map(v => v.response ? v.response : v) : []);
    return Array.isArray(_arr) && _arr[0] ? _arr[0].url : null;
  }, [user]);

  return isMobile ? (
    <div className="d-flex flex-column justify-content-center" onClick={toggleSettingsDrawer}>
      <UserIcon companyLogo={companyLogo} />
      <MobileDrawer
        mod={module}
        isUserDropdown
        toggle={toggleSettingsDrawer}
        drawerOpened={settingsDrawerOpened}
      />
    </div>
  ) : (
    <Dropdown
      trigger="click"
      placement="bottomLeft"
      rootClassName={formatClassname(['user-dropdown-layout', app])}
      menu={{
        items: [
          {
            label: (
              <>
                <div className="drop-header">
                  <h4>{user?.company?.name || ''}</h4>
                  <p>{user?.firstName || ''} {user?.lastName || ''}</p>
                </div>
                <div className='list'>
                  {module !== 'admin' ? <>
                    {/* {user.modules && user.modules[module] && isUserApproved && user.company && user.company.category !== 'individual' && !demo ? */}
                    {isUserApproved && !demo && canViewProjects && app === 'mmt' ?
                      <div className='list-item' onClick={() => {
                        if (notificationMode === NOTIFICATION_MODE.PROJECT_SOURCES) {
                          changeNotificationState({ onYes: () => goTo(`/app/${module}/projects`) });
                        } else {
                          goTo(`/app/${module}/projects`);
                        }
                      }}
                      >
                        {t('Projects')}
                      </div>
                      : null}
                    {isUserApproved && !demo && canViewPartners ?
                      <div className='list-item' onClick={() => {
                        goTo(`/app/${module}/partners`);
                      }}
                      >
                        {t('Partners')}
                      </div>
                      : null}
                    {user.modules && user.modules[module] && user.company && !demo && canViewUsers ?
                      <div className='list-item' onClick={() => {
                        if (notificationMode === NOTIFICATION_MODE.PROJECT_SOURCES) {
                          changeNotificationState({ onYes: () => goTo(`/app/${module}/users`) });
                        } else {
                          goTo(`/app/${module}/users`);
                        }
                      }}
                      >
                        {t('Users')}
                      </div>
                      : null}
                  </> : null}

                  {canViewSettings && !isAppNavigation ? (
                    <div className='list-item' onClick={() => {
                      if (notificationMode === NOTIFICATION_MODE.PROJECT_SOURCES) {
                        changeNotificationState({ onYes: () => goTo(`/app/${module}/profile`) });
                      } else {
                        goTo(`/app/${module}/view/settings`);
                      }
                    }}
                    >{t('Settings')}
                    </div>
                  ) : null}

                  {/* {!isAppNavigation ? <div className='list-break' /> : null} */}

                  {(!isAppNavigation && showApplications) ? (
                    <div
                      className={formatClassname(['list-item', !hasMultipleApps && 'disabled'])}
                      onClick={() => {
                        if (!hasMultipleApps) {
                          return;
                        }

                        if (notificationMode === NOTIFICATION_MODE.PROJECT_SOURCES) {
                          changeNotificationState({ onYes: () => goTo(`/app/${module}/profile`) });
                        } else {
                          goTo(`/app`);
                        }
                      }}
                    >{t('Applications')}
                    </div>
                  ) : null}

                  <div className='list-item' onClick={() => {
                    if (notificationMode === NOTIFICATION_MODE.PROJECT_SOURCES) {
                      changeNotificationState({ onYes: () => logOut() });
                    } else {
                      logOut();
                    }
                  }}>
                    {t('Log out')}
                  </div>
                </div>
              </>
            ),
            key: 'userMenu'
          }
        ]
      }}
    >
      <div className="d-flex flex-column justify-content-center">
        <UserIcon companyLogo={companyLogo} />
      </div>
    </Dropdown>
  );
}
